import React from "react";
import {Card} from "../modules/Tenants/index";

export function TenantsCardPage(props) {
  return (
    <Card {...props} />
  );
}
